
export const GET_PDF_REPORT_DATA = "GET_PDF_REPORT_DATA"
export const GET_PDF_REPORT_DATA_SUCCESS = 'GET_PDF_REPORT_DATA_SUCCESS'
export const GET_PDF_REPORT_DATA_ERROR = 'GET_PDF_REPORT_DATA_ERROR'





